import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Error no controlado en la calculadora:", error, info);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="grid min-h-screen place-items-center bg-slate-100 p-6 text-slate-800">
        <section className="w-full max-w-md rounded-2xl border border-rose-200 bg-white p-7 text-center shadow-xl">
          <AlertTriangle
            aria-hidden="true"
            className="mx-auto mb-4 h-10 w-10 text-rose-600"
          />
          <h1 className="text-lg font-black">
            La calculadora necesita recargarse
          </h1>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            Tus datos guardados permanecen en este navegador. Recarga la
            aplicación para continuar.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mx-auto mt-5 flex items-center gap-2 rounded-xl bg-[#231F60] px-5 py-2.5 text-sm font-bold text-white hover:bg-[#1d1a51]"
          >
            <RefreshCw aria-hidden="true" className="h-4 w-4" />
            Recargar
          </button>
        </section>
      </main>
    );
  }
}
